export function ModifiedIndicator() {
    return <div id='indicator' className='absolute -right-[3px] -top-[3px] h-2.5 w-2.5 rounded-full bg-blue-400' />;
}
